import type { LinkNavTab } from '@shared/ui/menus'

import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

interface TaskInfoMenuReturn {
  config: LinkNavTab[]
}

export const useTaskInfoMenu = (): TaskInfoMenuReturn => {
  const route = useRoute()
  const id = route.params.id as string

  const infoUrl = resolveUrl(AppRoute.TasksKanbanInfo, { id }) ?? ''
  const logUrl = resolveUrl(AppRoute.TasksKanbanLog, { id }) ?? ''

  const config: LinkNavTab[] = [
    {
      text: 'Task Info',
      to: infoUrl,
      selected: route.path === infoUrl,
      disabled: false,
      visible: true,
    },
    {
      text: 'Log',
      to: logUrl,
      selected: route.path === logUrl,
      disabled: false,
      visible: true,
    },
  ]

  return {
    config,
  }
}
